export const setSelectedAnimals = (subarea) => {
  return {
    type: 'setSelectedAnimal',
    subarea,
  };
};
